import React from "react";
import { ContactUsWrapper } from "./style";

const ContactUs = ({ header, content, contact: { html } }) => {
	return (
		<ContactUsWrapper>
			<h2>{header}</h2>
			{content && <p className="content">{content}</p>}
			<div
				className="rich-text"
				dangerouslySetInnerHTML={{ __html: html }}
			></div>
		</ContactUsWrapper>
	);
};

export default ContactUs;
